module.exports = __webpack_public_path__ + "img/cashier-icon-04.a99b4807.png";